import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=3935c2f0&scoped=true&"
import script from "./AppNotification.vue?vue&type=script&lang=js&"
export * from "./AppNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppNotification.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppNotification.vue?vue&type=style&index=1&id=3935c2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935c2f0",
  null
  
)

export default component.exports